import { ParameterInfos } from 'ut-business/parameter';

type MetricInfos = NonNullable<ParameterInfos['metric']>;
type ImperialInfos = NonNullable<ParameterInfos['imperial']>;
type TimeOfFlightInfos = NonNullable<ParameterInfos['timeOfFlight']>;
type InspectionModeInfos = NonNullable<ParameterInfos['inspectionMode']>;

export const DEFAULT_INSPECTION_MODE: InspectionModeInfos = {
  setup: {
    isReadOnly: false,
  },
  inspection: {
    isReadOnly: true,
  },
  pause: {
    isReadOnly: true,
  },
  analysis: {
    isReadOnly: false,
  },
};

export const POSITION_METRIC: MetricInfos = {
  unit: 'mm',
  decimals: 2,
  defaultStep: 1,
  steps: [
    0.01,
    0.1,
    1,
    10,
  ],
};

export const GATE_WIDTH_METRIC: MetricInfos = {
  ...POSITION_METRIC,
  limit: {
    min: 0,
  },
};

export const POSITION_IMPERIAL: ImperialInfos = {
  unit: 'in',
  decimals: 3,
  defaultStep: 0.05,
  steps: [
    0.005,
    0.05,
    0.5,
    5,
  ],
};

const TIME_OF_FLIGHT_PARAMETER_INFOS = {
  unit: 'µs',
  decimals: 3,
  defaultStep: 1,
  steps: [
    0.01,
    0.1,
    1,
    10,
  ],
} satisfies TimeOfFlightInfos;

export const POSITION_TIME_OF_FLIGHT: TimeOfFlightInfos = { ...TIME_OF_FLIGHT_PARAMETER_INFOS };

export const GATE_WIDTH_TIME_OF_FLIGHT: TimeOfFlightInfos = {
  ...TIME_OF_FLIGHT_PARAMETER_INFOS,
  limit: {
    min: 0,
  },
};
